import {
  Box,
  Button,
  Divider,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Logos from '../../components/logos';
import PageTransition from '../../components/PageTransition/PageTransition';
import Auth_APIs from '../../utilities/api/auth_api';
import TinkerLabListAPIs from '../../utilities/api/TinkersLab/TinkerLabListAPIs';
import background from '../../utilities/dummy_assets/background.png';

export default function RegisterMoreDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedAdminType, setSelectedAdminType] = useState('Admin');
  console.log('testt', location.state?.isStudentIdRequired);

  // States for form validation
  const [showValidation, setShowValidation] = useState(false);
  const [errors, setErrors] = useState({});

  // States for Admin form
  const [profilePic, setProfilePic] = useState(null);
  const [position, setPosition] = useState({ id: '', label: '' });
  const [degree, setDegree] = useState('');
  const [graduationYear, setGraduationYear] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [studentId, setStudentId] = useState('');
  const [tl, setTl] = useState('');
  const [intakeYear, setIntakeYear] = useState('');
  const [branch, setBranch] = useState('');
  const [tinkerLabsList, setTinkerLabsList] = useState([]);
  const studentEmail = location.state?.email || '';
  console.log('Location state:', location.state.TL);

  const POSITION_CHOICES = {
    'TL student management body': '0',
    'Manager (other technical clubs)': '1',
    'TL Manager': '2',
    'TL Technician': '3',
    Other: '4',
    'Professor In Charge': '5',
  };

  const dataURLtoBlob = dataurl => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  useEffect(() => {
    const fetchTinkerLabs = async () => {
      try {
        const response = await TinkerLabListAPIs.TinkerLabsListGet();
        setTinkerLabsList(response || []);
      } catch (error) {
        console.error('Failed to fetch tinker labs:', error);
        toast.error('Failed to load TL options. Please refresh the page.');
      }
    };
    fetchTinkerLabs();
  }, []);

  

  const filteredTLs = tinkerLabsList.filter(
    lab =>
      //lab.name !== 'MBF Admin' &&   //temporary disabled
      lab.accepted_ldaps.length > 0 &&
      lab.accepted_ldaps.some(domain => studentEmail.endsWith(domain))
  );

  // Auto-select if only one TL matches
  useEffect(() => {
    if (filteredTLs.length === 0) {
      setTl(''); // ensures explicit empty state
      return;
    } else if (!tl) {
      // Auto-select first matching TL
      setTl(filteredTLs[0].id);
    }
  }, [filteredTLs]);

  const validateForm = (field = null) => {
    const newErrors = { ...errors };

    const validateField = (fieldName, value, label, type = 'text') => {
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        newErrors[fieldName] = `${label} is required`;
      } else if (
        type === 'email' &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ) {
        newErrors[fieldName] = 'Please enter a valid email address';
      } else if (type === 'phone' && !/^\+?[0-9\s-]{10,}$/.test(value)) {
        newErrors[fieldName] = 'Please enter a valid phone number';
      } else if ((type === 'select' || type === 'tl') && value === '') {
        newErrors[fieldName] = `${label} is required`;
      } else {
        delete newErrors[fieldName];
      }
    };

    // Student ID validation
    if (
      (field === 'studentId' || field === null) &&
      location.state?.isStudentIdRequired
    ) {
      validateField('studentId', studentId, 'Student ID');
    } else if (field === 'studentId' || field === null) {
      delete newErrors.studentId;
    }

    // TL validation - check both tl state and location.state.TL
    if (field === 'tl' || field === null) {
      const tlValue =
        tl ||
        (location.state?.TL && location.state.TL !== ''
          ? location.state.TL
          : '');
      validateField('tl', tlValue, 'TL', 'tl');
    }

    // Branch validation
    if (field === 'branch' || field === null) {
      validateField('branch', branch, 'Branch', 'select');
    }

    // Current Year validation
    if (field === 'intakeYear' || field === null) {
      validateField('intakeYear', intakeYear, 'Intake Year', 'select');
    }

    // Graduation Year validation
    if (field === 'graduationYear' || field === null) {
      validateField(
        'graduationYear',
        graduationYear,
        'Graduation Year',
        'select'
      );
    }

    // Degree validation
    if (field === 'degree' || field === null) {
      validateField('degree', degree, 'Degree', 'select');
    }

    // Agreement validation
    // if (field === 'agreed' || field === null) {
    //   if (!agreed) {
    //     newErrors.agreed = 'You must agree to the terms and conditions';
    //   } else {
    //     delete newErrors.agreed;
    //   }
    // }

    // Profile picture validation
    if (field === 'profilePic' || field === null) {
      if (!profilePic) {
        newErrors.profilePic = 'Please upload a profile picture';
      } else {
        delete newErrors.profilePic;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const [prevFormData, setPrevFormData] = useState({});

  // useEffect(() => {
  //   if (location.state?.capturedImage) {
  //     const imageBlob = dataURLtoBlob(location.state.capturedImage);
  //     setProfilePic(imageBlob);
  //   }
  //   // if (location.state?.position) {
  //   //   setPosition(location.state.position);
  //   // }
  //   if (location.state?.formData) {
  //     setPrevFormData(location.state.formData);
  //   }

  // }, [location.state]);

  useEffect(() => {
    console.log('triggered');
    if (location.state?.capturedImage) {
      const imageBlob = dataURLtoBlob(location.state.capturedImage);
      setProfilePic(imageBlob);
    }

    // if (location.state?.formData) {
    //   const formData = location.state.formData;
    //   setPrevFormData(formData);

    //   // Restore current page fields if they exist
    //   if (formData.studentId) setStudentId(formData.studentId);
    //   if (formData.tl) setTl(formData.tl);
    //   if (formData.branch) setBranch(formData.branch);
    //   if (formData.degree) setDegree(formData.degree);
    //   if (formData.intakeYear) setIntakeYear(formData.intakeYear);
    //   if (formData.graduationYear) setGraduationYear(formData.graduationYear);
    //   if (formData.agreed !== undefined) setAgreed(formData.agreed);
    //   if (formData.profilePic) setProfilePic(formData.profilePic);
    // }

    if (location.state?.studentId && location.state?.isStudentIdRequired) {
      setStudentId(location.state.studentId);
    }

    if (location.state?.position) {
      setPosition(location.state.position);
    }

    if (location.state?.profilePic) {
      setProfilePic(location.state.profilePic);
    }

    if (location.state?.tl) {
      setTl(location.state.tl);
    }

    // If TL comes from location.state.TL instead of location.state.tl
    if (location.state?.TL && location.state.TL !== '') {
      setTl(location.state.TL);
    }

    if (location.state?.branch) {
      setBranch(location.state.branch);
    }

    if (location.state?.intakeYear) {
      setIntakeYear(location.state.intakeYear);
    }

    if (location.state?.graduationYear) {
      setGraduationYear(location.state.graduationYear);
    }

    if (location.state?.degree) {
      setDegree(location.state.degree);
    }

    // if(location.state?.agreed) {
    //   setAgreed(location.state.agreed);
    // }
  }, [location.state]);

  const handleTlChange = event => {
    setTl(event.target.value);
    validateForm('tl');
  };
  const handleRegister = async () => {
    console.log('=== HANDLE REGISTER FUNCTION CALLED ===');
    console.log('Initial state values:', {
      studentId,
      tl,
      branch,
      degree,
      intakeYear,
      graduationYear,
      locationState: location.state,
    });

    setShowValidation(true);
    const isValid = validateForm();
    console.log('Form validation result:', isValid);
    console.log('Validation errors:', errors);

    if (!isValid) {
      console.log('Validation failed, scrolling to first error');
      const firstError = Object.keys(errors)[0];
      if (firstError) {
        console.log('First error field:', firstError);
        const element = document.querySelector(`[data-error="${firstError}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }

    console.log('Validation passed, preparing form data');

    try {
      // Create FormData instance
      const formData = new FormData();

      // Use tl state if available, otherwise use location.state.TL
      const tlValue =
        tl ||
        (location.state?.TL && location.state.TL !== ''
          ? location.state.TL
          : '');

const selectedTL = filteredTLs.find(l => l.id === tlValue);

if (!selectedTL) {
  toast.error('Please select a valid TL');
  return;
}
      // Append text fields
      formData.append('name', location.state.name);
      formData.append('email', location.state.email);
      formData.append('phone_number', location.state.phone);
      formData.append('TL', selectedTL.name);
      formData.append('position', POSITION_CHOICES[position.label]);
      formData.append('branch', degree);
      formData.append('intake_year', intakeYear);
      formData.append('department', branch);
      formData.append('graduation_year', graduationYear);

      // if (location.state?.isStudentIdRequired) {
      //   formData.append('student_id', studentId)
      // }

      console.log('FormData prepared with values:', {
        name: location.state.name,
        email: location.state.email,
        phone: location.state.phone,
        TL: tlValue,
        position: POSITION_CHOICES[position.label],
        branch: degree,
        intake_year: intakeYear,
        department: branch,
        graduation_year: graduationYear,
      });

      // Handle profile picture
      if (location.state.profilePic) {
        console.log(
          'Processing profile picture, type:',
          typeof location.state.profilePic
        );

        if (location.state.profilePic instanceof File) {
          console.log('Profile pic is a File object');
          formData.append('profile_pic', location.state.profilePic);
        } else if (
          typeof location.state.profilePic === 'string' &&
          location.state.profilePic.startsWith('data:image')
        ) {
          console.log('Profile pic is base64 string, converting to blob');
          const response = await fetch(location.state.profilePic);
          const blob = await response.blob();
          const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' });
          formData.append('profile_pic', file);
          console.log('Base64 converted to File object');
        } else {
          console.warn('Profile pic format not recognized');
        }
      } else {
        console.warn('No profile picture found in location.state');
      }

      console.log('Sending registration request to API');
      const response = await Auth_APIs.register(formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('API response received:', {
        status: response?.status,
        data: response?.data,
      });

      if (response && (response.status === 200 || response.status === 201)) {
        console.log('Registration successful, navigating to check-status page');

        const registrationData = {
          email: location.state.email,
          name: location.state.name,
          phone: location.state.phone,
          ...(studentId && { studentId: studentId }),
          tl: tlValue,
          position: position,
          branch: branch,
          degree: degree,
          intakeYear: intakeYear,
          graduationYear: graduationYear,
          agreed: agreed,
          profilePic: location.state.profilePic,
          status: 'pending',
        };

        console.log('Registration data for navigation:', registrationData);

        navigate('/check-status', {
          state: { registrationData },
        });
        return;
      }

      // Handle unexpected response status
      console.error('Unexpected response status:', response?.status);
      const errorMessage =
        response?.data?.message || 'Registration failed. Please try again.';
      throw new Error(errorMessage);
    } catch (error) {
      if (error.email) {
        toast.error(
          'Email ID already registered or registration in progress. Please use a different email or contact admin.'
        );
        return;
      }
      console.error('=== REGISTRATION ERROR ===');
      console.error('Error object:', error);
      console.error('Error type:', error.constructor.name);

      let errorMessage = 'An error occurred during registration';

      if (error.response) {
        // Server responded with a status code outside 2xx
        console.error('Server error response:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
        });
        errorMessage =
          error.response.data?.message ||
          error.response.statusText ||
          errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        console.error('No response received from server:', error.request);
        errorMessage = 'No response from server. Please check your connection.';
      } else {
        // Error occurred in setting up the request
        console.error('Request setup error:', error.message);
        errorMessage = error.message;
      }

      console.error('Final error message:', errorMessage);
      toast.error(errorMessage);
    }
  };

  const handleBackNavigation = () => {
    console.log(
      studentId,
      branch,
      intakeYear,
      graduationYear,
      degree,
      tl,
      position
    );
    navigate('/register-submit-2', {
      state: {
        ...location.state,
        // ...(studentId && { studentId: studentId }),
        //branch: branch,
        //intakeYear: intakeYear,
        //graduationYear: graduationYear,
        //degree: degree,
        //tl: tl,
        position: position,
      },
    });
  };

  // Form is valid, proceed with registration
  // const formData = {
  //   email: mbfEmail,
  //   name: mbfName,
  //   currentYear: currentYear,
  //   position: position,
  //   profilePic: profilePic
  // };

  // console.log("Form submitted successfully:", formData);
  // // Navigate to the next page or submit to API
  // navigate("/register-submit-3", {
  //   state: {
  //     capturedImage: profilePic,
  //     position: position,
  //     formData: formData
  //   }
  // });
  // };

  return (
    <Box
      sx={{
        // width: "100vw",
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'flex',
        // justifyContent: "center",
        alignItems: 'center',
        backgroundImage: { sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: '1rem',
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top right link */}
      <Box sx={{ position: 'absolute', top: 16, right: 32 }}>
        <Typography
          component="a"
          href="/student"
          sx={{ color: '#007bff', textDecoration: 'underline' }}
        >
          Go to student site
        </Typography>
      </Box>

      {/* Main Box containing toggle + form */}
      <PageTransition
        sx={{
          maxWidth:
            selectedAdminType === 'Admin'
              ? { xs: 400, sm: '50%' }
              : { xs: 900, sm: '60%' },
          margin: 'auto',
          background: '#fff',
          marginTop: { xs: 10, sm: 'auto' },
          p: { sm: 2 },
          borderRadius: '10px',
          boxShadow: { sm: '0px 0px 20px rgba(0,0,0,0.1)' },
        }}
      >
        {/* Toggle buttons inside main box */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            border: { xs: '1px solid #E6E6E6', sm: 'none' },
            borderTopLeftRadius: { xs: '10px' },
            borderTopRightRadius: { xs: '10px' },
          }}
        >
          <Button
            onClick={() => setSelectedAdminType('Admin')}
            sx={{
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'Admin' ? '#000' : '#ccc',
              borderBottom:
                selectedAdminType === 'Admin' ? '2px solid black' : 'none',

              borderRadius: 0,
              flex: 1,
            }}
          >
            Admin
          </Button>
          <Button
            // onClick={() => setSelectedAdminType("MBF Admin")}
            sx={{
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'MBF Admin' ? '#000' : '#ccc',
              borderBottom:
                selectedAdminType === 'MBF Admin' ? '2px solid black' : 'none',

              borderRadius: 0,
              flex: 1,
            }}
          >
            MBF Admin
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />

        {/* <Box
            sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 2,
            mb: 2,
            }}
        >
            <TextField
              label="Student ID"
              value={mbfEmail}

            />
            <TextField
              label="Branch"
              value={mbfName}
            />
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
              <TextField
                label="Current Year"
                value={mbfPhone}
               
              />
              <TextField
                label="Degree"
                value={mbfPhone}
               
              />
               <TextField
                label="Graduation Year"
                value={mbfPhone}
                
              />
            </Box>
        </Box> */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: location.state?.isStudentIdRequired ? '1fr 1fr' : '1fr',
            },
            gap: 1,
            // mb: 1,
          }}
        >
          {/* Student ID - text field */}
          {location.state?.isStudentIdRequired && (
            <TextField
              label="Student ID"
              value={studentId}
              onChange={e => {
                setStudentId(e.target.value);
                validateForm('studentId');
              }}
              onBlur={() => validateForm('studentId')}
              error={showValidation && !!errors.studentId}
              helperText={showValidation && errors.studentId}
              required
              fullWidth
              inputProps={{
                'data-error': 'mbfEmail',
                'aria-describedby': 'student-id-helper',
              }}
              sx={{ mb: 1, textAlign: 'left' }}
            />
          )}

          {/* Branch Dropdown */}
          <TextField
            select
            fullWidth
            label="Degree"
            value={degree}
            onChange={e => {
              setDegree(e.target.value);
              validateForm('degree');
            }}
            onBlur={() => validateForm('degree')}
            error={showValidation && !!errors.degree}
            helperText={showValidation && errors.degree}
            required
            sx={{ mb: 2, textAlign: 'left' }}
            inputProps={{
              'data-error': 'degree',
              'aria-describedby': 'degree-helper',
            }}
          >
            <MenuItem value="B.Tech">B.Tech</MenuItem>
            <MenuItem value="B.E">B.E</MenuItem>
            <MenuItem value="M.Tech">M.Tech</MenuItem>
            <MenuItem value="M.Sc">M.Sc</MenuItem>
            <MenuItem value="PhD">PhD</MenuItem>
            <MenuItem value="MCA">MCA</MenuItem>
            <MenuItem value="MBA">MBA</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
        </Box>

        {/* Current Year and Graduation Year in one line */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 1,
            gridColumn: '1 / -1',
          }}
        >
          <TextField
            select
            fullWidth
            label="Intake Year"
            value={intakeYear}
            onChange={e => {
              setIntakeYear(e.target.value);
              validateForm('intakeYear');
            }}
            onBlur={() => validateForm('intakeYear')}
            error={showValidation && !!errors.intakeYear}
            helperText={showValidation && errors.intakeYear}
            required
            sx={{ mb: 1, textAlign: 'left' }}
            inputProps={{
              'data-error': 'intakeYear',
              'aria-describedby': 'intake-year-helper',
            }}
          >
            <MenuItem value="">Select Year</MenuItem>
            {Array.from({ length: 4 }, (_, i) => {
              const year = new Date().getFullYear() - 3 + i;
              return (
                <MenuItem key={year} value={year.toString()}>
                  {year}
                </MenuItem>
              );
            })}
          </TextField>

          <TextField
            select
            fullWidth
            label="Graduation Year"
            value={graduationYear}
            onChange={e => {
              setGraduationYear(e.target.value);
              validateForm('graduationYear');
            }}
            onBlur={() => validateForm('graduationYear')}
            error={showValidation && !!errors.graduationYear}
            helperText={showValidation && errors.graduationYear}
            required
            sx={{ mb: 1, textAlign: 'left' }}
            inputProps={{
              'data-error': 'graduationYear',
              'aria-describedby': 'grad-year-helper',
            }}
          >
            <MenuItem value="">Select Year</MenuItem>
            {Array.from({ length: 6 }, (_, i) => {
              const year = new Date().getFullYear() + i;
              return (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              );
            })}
          </TextField>
        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 1,
            mt: 1,
            gridColumn: '1 / -1',
          }}
        >
          {/* Degree field full width */}
          <TextField
            select
            label="Branch"
            value={branch}
            onChange={e => {
              setBranch(e.target.value);
              validateForm('branch');
            }}
            onBlur={() => validateForm('branch')}
            error={showValidation && !!errors.branch}
            helperText={showValidation && errors.branch}
            required
            fullWidth
            inputProps={{
              'data-error': 'branch',
              'aria-describedby': 'branch-helper',
            }}
            sx={{ mb: 1, textAlign: 'left' }}
          >
            <MenuItem value="CSE">Computer Science and Engineering</MenuItem>
            <MenuItem value="ECE">
              Electronics and Communication Engineering
            </MenuItem>
            <MenuItem value="ME">Mechanical Engineering</MenuItem>
            <MenuItem value="CE">Civil Engineering</MenuItem>
            <MenuItem value="EE">Electrical Engineering</MenuItem>
            <MenuItem value="CHE">Chemical Engineering</MenuItem>
            <MenuItem value="MME">
              Metallurgical and Materials Engineering
            </MenuItem>
            <MenuItem value="BT">Biotechnology</MenuItem>
            <MenuItem value="CL">Chemistry</MenuItem>
            <MenuItem value="MA">Mathematics</MenuItem>
            <MenuItem value="PH">Physics</MenuItem>
            <MenuItem value="HSS">Humanities and Social Sciences</MenuItem>
            <MenuItem value="MC">Mathematics and Computing</MenuItem>
            <MenuItem value="MSE">Materials Engineering</MenuItem>
            <MenuItem value="AR">Automation and Robotics</MenuItem>
            <MenuItem value="IT">Information Technology</MenuItem>
            <MenuItem value="AE">Aerospace Engineering</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          <TextField
            //select={!location.state.TL || location.state.TL === ''}
            select
            fullWidth
            label="TL"
            value={tl}
            onChange={handleTlChange}
            onBlur={() => validateForm('tl')}
            error={showValidation && !!errors.tl}
            helperText={(showValidation && errors.tl) || ' '}
            required
            disabled={filteredTLs.length === 1}
            SelectProps={{ displayEmpty: true }}
            sx={{
              mb: 1,
              textAlign: 'left',
              '& .MuiOutlinedInput-root': {
                '&.Mui-error fieldset': {
                  borderColor:
                    showValidation && errors.tl
                      ? '#d32f2f'
                      : 'rgba(0, 0, 0, 0.23)',
                },
                '&:hover fieldset': {
                  borderColor:
                    showValidation && errors.tl
                      ? '#d32f2f'
                      : 'rgba(0, 0, 0, 0.23)',
                },
                '&.Mui-focused fieldset': {
                  borderColor:
                    showValidation && errors.tl ? '#d32f2f' : '#1976d2',
                },
              },
              '& .MuiFormHelperText-root': {
                color:
                  showValidation && errors.tl
                    ? '#d32f2f'
                    : 'rgba(0, 0, 0, 0.6)',
              },
            }}
            inputProps={{
              'data-error': 'tl',
              'aria-describedby': 'tl-helper',
              'aria-invalid': !!(showValidation && errors.tl),
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0,
                marginTop: 0.5,
                fontSize: '0.75rem',
                lineHeight: 1.66,
                letterSpacing: '0.03333em',
              },
            }}
          >
            {filteredTLs.map(lab => (
              <MenuItem key={lab.id} value={lab.id}>
                {lab.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            // mb: 2,
            // mt: 2,
            border: showValidation && !agreed ? '1px solid #d32f2f' : '1px solid transparent',
            borderRadius: '4px',
            p: showValidation && !agreed ? '8px' : '0',
            backgroundColor: showValidation && !agreed ? '#fff5f5' : 'transparent'
          }}
          data-error="agreed"
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={agreed}
                onChange={(e) => {
                  setAgreed(e.target.checked);
                  validateForm('agreed');
                }}
                onBlur={() => validateForm('agreed')}
                sx={{
                  color: showValidation && !agreed ? "#d32f2f" : undefined,
                  "&.Mui-checked": { color: "#007bff" },
                  padding: '8px',
                  marginRight: '4px'
                }}
                inputProps={{
                  'data-error': 'agreed',
                  'aria-describedby': 'terms-helper-text'
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: showValidation && !agreed ? "#d32f2f" : "inherit",
                  fontSize: "14px",
                  margin: 0,
                  lineHeight: '1.5',
                  paddingLeft: '4px'
                }}
                id="terms-helper-text"
              >
                By using the MBF MIS, you consent to the processing of your information.*
              </Typography>
            }
            sx={{
              margin: 0,
              '& .MuiFormControlLabel-label': {
                margin: 0
              }
            }}
          />
        </Box>
        {showValidation && !agreed && (
          <Typography color="error" variant="caption" display="block" sx={{ mt: -1, mb: 1 }}>
            {errors.agreed}
          </Typography>
        )} */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 2,
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate('/login')}
            sx={{ flex: 1 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              console.log('Button clicked!');
              handleRegister();
            }}
            sx={{
              backgroundColor: '#007bff',
              fontSize: '16px',
              fontWeight: 'bold',
              flex: 1,
            }}
          >
            Register
          </Button>
        </Box>

        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              color: '#007BFF',
              fontWeight: 500,
              fontSize: '16px',
              cursor: 'pointer',
              px: '5px',
            }}
            onClick={handleBackNavigation}
          >
            &lt;
            <Typography
              component="span"
              sx={{
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              back
            </Typography>
          </Typography>
          <Box>
            Already Have an Account?
            <Button variant="text" onClick={() => navigate('/login')}>
              Login
            </Button>
          </Box>
        </Box>
      </PageTransition>

      {/* Footer Logos */}
      <Logos />
    </Box>
  );
}
